import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { useLocation, useNavigate } from "react-router";

export const PlaybookBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          display="icon"
          onClick={() => {
            const isFromDiscover = !!location.state?.fromDiscover;
            const to = isFromDiscover ? `/playbooks/discover` : `/playbooks`;
            navigate(to, { replace: true });
          }}
          className="mt-1"
        >
          <Icon icon="arrow_back" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{location.state?.fromDiscover ? "Back to discover" : "All playbooks"}</TooltipContent>
    </Tooltip>
  );
};
